import { useTranslation } from "react-i18next";
import {
  AutoComplete,
  FormContainer,
  FormInput,
  ISelectType,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { IEstablishmentsProps } from "./models";
import {
  createTicketAutomationReceivedRuleEstablishment,
  getTicketAutomationReceivedRuleEstablishmentById,
  updateTicketAutomationReceivedRuleEstablishmentById,
  getAllEstablishmentsList,
} from "../../../../../../../services/ticketAutomationReceivedRuleEstablishment.service";
import {
  establishmentsSchema,
  TEstablishmentsForm,
} from "./establishmentsSchema";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleEstablishment.";

const Establishments = ({
  id,
  ticketAutomationReceivedRuleId,
  onBackButton,
}: IEstablishmentsProps) => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTicketAutomationReceivedRuleEstablishment,
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTicketAutomationReceivedRuleEstablishmentById,
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTicketAutomationReceivedRuleEstablishmentById,
  );

  const { sendRequest: sendEstablishmentsRequest } = useFetch(
    getAllEstablishmentsList,
  );

  const [optionsEstablishments, setOptionsEstablishments] = useState<
    ISelectType[]
  >([]);

  // 1. DISPARAR UPDATE (PUT)
  const updateHandler = (v: TEstablishmentsForm, id: string) =>
    update({
      item: {
        id,
        establishmentId: v.establishment.id,
        establishmentName: v.establishmentName, // Aqui vai o apelido digitado
        ticketAutomationReceivedRuleId: ticketAutomationReceivedRuleId ?? "",
      },
      id,
    });

  // 2. DISPARAR SALVAR (POST)
  const saveHandler = (v: TEstablishmentsForm) =>
    save({
      establishmentId: v.establishment.id,
      establishmentName: v.establishmentName, // Aqui vai o apelido digitado
      ticketAutomationReceivedRuleId: ticketAutomationReceivedRuleId ?? "",
    });

  // 3. DISPARAR BUSCA DOS DADOS EDITADOS (GET por ID)
  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TEstablishmentsForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TEstablishmentsForm = {
          ...data,
          establishment: {
            id: data.establishmentId,
            name: data.originalEstablishmentName ?? "",
          },
          establishmentName: data.establishmentName, // Alimenta o campo de texto do Apelido
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  // 4. BUSCAR OPÇÕES PARA O SELECT (Lista geral de estabelecimentos da empresa)
  const fetchEstablishments = useCallback(async () => {
    const { data, success } = await sendEstablishmentsRequest(undefined);
    if (data && success) {
      setOptionsEstablishments(
        data.map((est: any) => ({
          id: est.id,
          name: est.name,
        })),
      );
    }
  }, [sendEstablishmentsRequest]);

  useEffect(() => {
    fetchEstablishments();
  }, [fetchEstablishments]);

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TEstablishmentsForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "establishment")}
      schema={establishmentsSchema}
      subtitle={t(translationPath + "new_establishment")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={onBackButton}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          {/* Seleção do Estabelecimento Base */}
          <Grid item xs={12} sm={6}>
            <AutoComplete
              fullWidth
              options={optionsEstablishments}
              name="establishment"
              label={
                t(translationPath + "establishment_field") || "Estabelecimento"
              }
              getOptionLabel={(option) => option.name}
              size="small"
            />
          </Grid>

          {/* Campo de Texto livre para digitar o Apelido */}
          <Grid item xs={12} sm={6}>
            <FormInput
              fullWidth
              name="establishmentName"
              label={
                t(translationPath + "establishment_name_field") ||
                "Apelido do Estabelecimento"
              }
              size="small"
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default Establishments;
